import { RootState } from '@/store';
import { State } from './state';
import {  ActionTree } from 'vuex';

import {
    FETCH_SYSTEM_LIST,
    SET_SYSTEM_LIST,
    UPDATE_REGISTER_FORM_VISIBILITY,
    SET_REGISTER_FORM_VISIBILITY,
    UPDATE_SELECTED_SYSTEM,
    SET_SELECTED_SYSTEM,
    CREATE_NEW_SYSTEM,
    UPDATE_SYSTEM_LIST,
    UPDATE_SYSTEM,
    ADD_SYSTEM_TO_LIST,
    CREATE_SYSTEM_LIST,
} from './types';
import { systemApi } from '@/api/system.api';
import { ISystem } from '../models';
import { MessageService } from '@/services/messageService';


export const actions: ActionTree<State, RootState> = {
    async [FETCH_SYSTEM_LIST]({ commit }, payload: State) {
        return systemApi.getAll().catch((error: any) => {MessageService.Error('Erro', error); } );
    },
    async [CREATE_SYSTEM_LIST]({ commit }, payload: State) {
        commit(SET_SYSTEM_LIST, payload);
    },
    async [UPDATE_REGISTER_FORM_VISIBILITY]({ commit }, payload: boolean) {
        commit(SET_REGISTER_FORM_VISIBILITY, payload);
    },
    async [UPDATE_SELECTED_SYSTEM]({commit}, payload: State) {
        commit(SET_SELECTED_SYSTEM, payload);
    },
    async [UPDATE_SYSTEM_LIST]({commit}, payload: ISystem) {
        commit(ADD_SYSTEM_TO_LIST, payload);
    },
    async [CREATE_NEW_SYSTEM]({commit}, payload: ISystem) {
        return systemApi.addSystem(payload).catch((error: any) => {MessageService.Error('Erro', error); } );
    },
    async [UPDATE_SYSTEM]({commit}, payload: ISystem) {
        return systemApi.updateSystem(payload).catch((error: any) => {MessageService.Error('Erro', error); } );
    },
};
